/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetInstrumentLinkingOptionsAppRequest} from '@cash-web/protos/squareup/cash/lynx/api/v1_0/app/GetInstrumentLinkingOptions.pb'
import {GetInstrumentLinkingOptionsAppResponse} from '@cash-web/protos/squareup/cash/lynx/api/v1_0/app/GetInstrumentLinkingOptions.pb'


export const getInstrumentLinkingOptionsApp = (request: GetInstrumentLinkingOptionsAppRequest, options?: CashRequestOptions) => post<GetInstrumentLinkingOptionsAppRequest, GetInstrumentLinkingOptionsAppResponse>("/cash-app/instrument-link/v1.0/get-instrument-linking-options", request, {...options, rejectOnError: true })